import { useEffect } from "react"

/**
 * Locks page scroll by setting `document.body.style.overflow = "hidden"`
 * when `isLocked` is true, and restores it on unlock or unmount.
 */
export default function useScrollLock(isLocked: boolean) {
  useEffect(() => {
    if (isLocked) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
    return () => {
      document.body.style.overflow = ""
    }
  }, [isLocked])
}
